<template>
    <Mfm
        :class="$style.root"
        :mm="magMaybeProperty(user, 'display_name_mm')"
        :fallback="user.username"
        :text="magTransUsername(user)"
        :plain="true"
        :nowrap="nowrap"
        :custom-emojis="user.emojis"
        :strip-emoji="removeEmojiFromUsernames"
        emoji-size="small"
    />
</template>

<script lang="ts" setup>
import * as misskey from "calckey-js";
import { packed } from "magnetar-common";
import { magMaybeProperty, magTransUsername } from "@/scripts-mag/mag-util";
import { useSettingsStore } from "@/store/settings-store";
import { storeToRefs } from "pinia";
import { refProp } from "@/composables/reactive";

withDefaults(
    defineProps<{
        user: packed.PackUserBase | misskey.entities.User;
        nowrap?: boolean;
    }>(),
    {
        nowrap: true,
    }
);

const settingsStore = useSettingsStore();
const { settings } = storeToRefs(settingsStore);
const removeEmojiFromUsernames = refProp(settings, "removeEmojiFromUsernames");
</script>

<style lang="scss" module>
.root {
    unicode-bidi: isolate;
}
</style>
